var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 171,
    viewBox: "0 0 160 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.957 91.1178C146.659 90.2662 142.022 93.9564 141.265 99.0658C139.373 112.029 133.412 123.856 123.95 133.318C99.9171 157.351 60.9343 157.256 36.9958 133.318C13.0573 109.379 13.0573 70.3017 36.9958 46.3632C45.9845 37.3744 57.4334 31.5081 70.1123 29.3319C75.6001 28.2911 81.4665 28.1018 87.6167 28.7642C96.0378 29.7103 103.796 32.5489 110.987 36.6175L98.6871 38.6991C93.5777 39.5507 90.0768 44.4708 90.9283 49.5802C91.6853 54.2165 95.7539 57.4336 100.201 57.4336C100.769 57.4336 101.242 57.4336 101.809 57.339L134.831 51.6618C137.291 51.2834 139.468 49.8641 140.982 47.7825C142.401 45.7009 142.969 43.2408 142.59 40.6861L136.913 7.66421C136.061 2.55481 131.236 -0.946081 126.032 -0.0945141C120.922 0.757053 117.422 5.67722 118.273 10.7866L119.787 19.4915C110.609 14.3821 100.485 11.0705 89.7929 9.84044C81.7504 8.89425 73.9916 9.17811 66.8006 10.5028C50.337 13.2467 35.4819 21.0054 23.6545 32.7381C-7.85344 64.3407 -7.85344 115.435 23.5599 146.754C39.2666 162.46 59.7988 170.314 80.4257 170.314C101.053 170.314 121.585 162.46 137.291 146.754C149.592 134.453 157.445 118.936 159.905 101.904C160.662 96.7003 157.067 91.9694 151.957 91.2124V91.1178Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a30d6313.svg";
export { ForwardRef as ReactComponent };